import Cookies from 'js-cookie'

// 初始化cookies的配置
const defaultSettings = { SameSite: 'None', Secure: true }
const converter = {
  write: function (value, _) {
    return typeof value === 'object' ? JSON.stringify(value) : value
  },
  read: function (value, key) {
    if (
      key === 'GladPermission' ||
      key === 'GladAddressGps' ||
      key === 'GladTeamRoles'
    ) {
      return JSON.parse(value)
    }
    return Cookies.converter.read(value, key)
  },
}
const configCookies =
  Cookies.withAttributes(defaultSettings).withConverter(converter)

// 登入時設置cookies
export const initLoginCookies = (data) => {
  configCookies.set('user', data.token)
  configCookies.set('GladName', data.managerName)
  configCookies.set('GladPosition', data.positionInfo.positionName)
  configCookies.set('GladPermission', JSON.stringify(data.positionInfo.auth))
  configCookies.set('GladTeamCode', data.teamCode)
  configCookies.set('GladArea', data.area)
  configCookies.set('GladAddressGps', data.addressGps)
  configCookies.set('GladCompanyServicePhone', data.servicePhone)
  configCookies.set('GladTeamName', data.teamName)
  configCookies.set('Flag', 'user')
  configCookies.set('GladServiceNumber', data.passengerAccount)
  // 將 teamRoles 存到 cookies
  if (data.teamRoles && Array.isArray(data.teamRoles)) {
    configCookies.set('GladTeamRoles', JSON.stringify(data.teamRoles))
  }
}

// 登出時移除cookies
export const logoutCookies = () => {
  configCookies.remove('user')
  configCookies.remove('GladName')
  configCookies.remove('GladPosition')
  configCookies.remove('GladPermission')
  configCookies.remove('GladTeamCode')
  configCookies.remove('GladArea')
  configCookies.remove('GladAddressGps')
  configCookies.remove('GladCompanyServicePhone')
  configCookies.remove('GladTeamName')
  configCookies.remove('Flag')
  configCookies.remove('GladServiceNumber')
  configCookies.remove('socketConnectState')
  configCookies.remove('GladTeamRoles')
  // 清除 Vuex 中的 teamRoles（從 window 取得 store 避免循環依賴）
  if (window.__VUE_STORE__ && window.__VUE_STORE__.commit) {
    try {
      window.__VUE_STORE__.commit('managerStore/SET_TEAM_ROLES', [])
    } catch (e) {
      // 如果 commit 失敗，忽略錯誤（不影響登出流程）
    }
  }
}

// 從 cookies 恢復 teamRoles 到 Vuex
export const restoreTeamRolesFromCookies = () => {
  try {
    const teamRoles = configCookies.get('GladTeamRoles')
    if (teamRoles && Array.isArray(teamRoles)) {
      if (window.__VUE_STORE__ && window.__VUE_STORE__.commit) {
        window.__VUE_STORE__.commit('managerStore/SET_TEAM_ROLES', teamRoles)
      }
    }
  } catch (e) {
    // 如果恢復失敗，忽略錯誤
    console.warn('無法從 cookies 恢復 teamRoles', e)
  }
}

// output 設置完成的cookies
export const cookies = configCookies



// WEBPACK FOOTER //
// ./src/utils/cookies.js